import { faCheck, faCopy } from "@fortawesome/pro-regular-svg-icons";
import { Button, Icon, Tooltip } from "@intility/bifrost-react";
import { useState } from "react";
import type { ManualStep } from "../lib/wireUpManual";

// A snippet in a box with a copy button in its corner.
function CodeBlock({ code }: { code: string }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }
  return (
    <div className="client-wireup-code">
      <pre>{code}</pre>
      <Tooltip content={copied ? "Copied" : "Copy"}>
        <Button
          variant="flat"
          small
          className="client-icon-button client-wireup-code-copy"
          aria-label="Copy"
          onClick={copy}
        >
          <Icon icon={copied ? faCheck : faCopy} />
        </Button>
      </Tooltip>
    </div>
  );
}

// The numbered steps of the manual setup, each with what to do and, where there
// is one, a snippet to copy.
export function ClientWireUpSteps({ steps }: { steps: ManualStep[] }) {
  return (
    <ol className="client-wireup-steps">
      {steps.map((step) => (
        <li key={step.title}>
          <h5 className="bf-h5" style={{ margin: 0 }}>
            {step.title}
          </h5>
          {step.text && (
            <p className="bf-p bfc-base-2" style={{ margin: 0 }}>
              {step.text}
            </p>
          )}
          {step.code && <CodeBlock code={step.code} />}
        </li>
      ))}
    </ol>
  );
}
